// Actions for the global "layers on/off" eye toggle on the main map (WEB-7048).
// The state is a single boolean: whether the user's active layers are drawn.
// It never touches the active-layer selection itself (user setting 1) — only
// what is rendered — so flipping it back restores exactly what was there.
// Session-only (blacklisted from redux-persist), matching iOS/Android, where
// MapController.layersVisible is in-memory and resets each session.

export const LAYERS_VISIBILITY_TOGGLE = 'LAYERS_VISIBILITY_TOGGLE'
export const LAYERS_VISIBILITY_SHOW = 'LAYERS_VISIBILITY_SHOW'

export const toggleLayersVisibility = () => ({
  type: LAYERS_VISIBILITY_TOGGLE,
})

// Force layers back on. Dispatched when the user activates a layer from the
// Map Layers panel: acting on a layer while everything is hidden would
// otherwise look like the tap did nothing.
export const showLayers = () => ({
  type: LAYERS_VISIBILITY_SHOW,
})
